const dataFilterLargeSmall = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.5 13V3.6"/><polyline points="1 6.14 3.53 3 6 6.08"/><path d="M7.31 4.39H15"/><path d="M7.31 8.12h6.59"/><path d="M7.31 11.85h5.49"/></svg>',
};

export { dataFilterLargeSmall as default };
